import { useFormContext } from 'react-hook-form';
import { Input, InputProps } from '../components';
import { FormField } from './BaseFormComponents';
import { BaseFormFieldWrapper } from './BaseFormFieldWrapper';
import { FormComponentBaseProps } from './types/form-base-props';

export type FormTextFieldProps = FormComponentBaseProps &
  InputProps & {
    formatValue?: (value: string) => string | null;
    disableAutocomplete?: boolean;
  };

const FormTextField = ({
  formatValue,
  description,
  descriptionProps,
  label,
  labelProps,
  hideError,
  defaultValue,
  name,
  disabled,
  disableAutocomplete,
  required,
  Icon,
  ...props
}: FormTextFieldProps) => {
  const { control, formState } = useFormContext();
  const { isSubmitting } = formState;

  return (
    <FormField
      shouldUnregister={false}
      disabled={disabled}
      name={name}
      defaultValue={defaultValue}
      control={control}
      render={({ field }) => (
        <BaseFormFieldWrapper
          description={description}
          descriptionProps={descriptionProps}
          label={label}
          labelProps={labelProps}
          hideError={hideError}
          required={required}
          Icon={Icon}
        >
          <Input
            {...field}
            disabled={disabled || isSubmitting}
            value={String(
              (formatValue ? formatValue(field.value) : field.value) ?? ''
            )}
            {...props}
            disableAutocomplete={disableAutocomplete}
          />
        </BaseFormFieldWrapper>
      )}
    />
  );
};

export { FormTextField };
